<template>
  <section class="mb-0 auto-height" id="construction">
      <div class="container">
        <h3 class="text-center mb-0">工程進度</h3>
        <br>
        <div v-if="sites.length>0">
          <!-- <p>※ 手機版已自動調整大小，無需點擊</p> -->
          <select v-if="curSite<sites.length" v-model="curSite" class="custom-select" @change="displayImgIdx=-1">
            <option v-for="(site, i) in sites" :value="i" :key="site.id">{{ site.name }}</option>
          </select>
          <select v-if="curSite<sites.length&&curWeek<sites[curSite].weeks.length" v-model="curWeek" class="custom-select" @change="displayImgIdx=-1">
            <option v-for="(week, i) in sites[curSite].weeks" :value="i" :key="week.week">第{{ week.week }}週 {{ getDate(sites[curSite].name, week.week) }}</option>
          </select>
          <br>
          <div v-if="displayImgIdx>=0" class="text-center">
            <div class="clickable" style="width:100%" @click="displayImgIdx=-1">
              <img v-if="curPic.type==='img'" class="sitePic" :src="curPic.url">
              <div v-else class="embed-responsive embed-responsive-16by9 sitePic">
                <iframe class="embed-responsive-item" :src="curPic.url" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
              <p class="text-center pic-name">{{ curPic.name }}</p>
              <p class="text-center text-muted pic-note">點此縮小</p>
            </div>
          </div>
          <div v-else class="text-left">
            <div class="sitePicDiv align-top clickable" v-for="(pic, i) in sites[curSite].weeks[curWeek].sitepics" :key="i" @click="smallPicClickHandler(pic, i)">
              <img v-if="pic.type==='img'" class="sitePic" :src="pic.url">
              <div v-else class="embed-responsive embed-responsive-16by9 sitePic">
                <iframe class="embed-responsive-item" :src="pic.url" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
              <p class="text-center pic-name">{{ pic.name }}</p>
              <p v-if="!isSmallScreen()" class="text-center text-muted pic-note">點此放大</p>
            </div>
          </div>
        </div>
        <div v-else>
          ※ 敬請期待
        </div>
      </div>
  </section>
</template>

<script>
export default {
  name: 'CaseList',
  props: {
    sites: Array,
    weekDates: Object,
  },
  data() {
    return {
      curSite: 0,
      curWeek: 0,
      displayImgIdx: -1,
    }
  },
  computed: {
    curPic: function() {
      return this.sites[this.curSite].weeks[this.curWeek].sitepics[this.displayImgIdx];
    }
  },
  methods: {
    isSmallScreen() {
      if(window.outerWidth){
        return window.outerWidth < 992;
      }
      else {
        return document.body.clientWidth < 992;
      }
    },
    smallPicClickHandler(pic, i) {
      if(!this.isSmallScreen()) {
        this.displayImgIdx = i;
      } else {
        window.open(pic.url, '_blank');
      }
    },
    getDate(caseName, week) {
      const weekDate = this.weekDates[caseName] || {};
      return weekDate[week] || '';
    },
  }
}
</script>

<style scoped>
.custom-select {
  display: inline-block;
  width: 30%;
}
.sitePicDiv {
  display:inline-block;
  width:100%;
}
.sitePic {
  max-width: 100%;
  margin-top: 4vh;
}
.pic-name {
  font-size: 1.2rem;
  margin-top: 0.5rem;
  margin-bottom: 0;
}
.pic-note {
  font-size: 0.8rem;
  margin-top: 0.5rem;
  margin-bottom: 0;
}
@media (min-width: 992px) {
  .custom-select {
    width: 20%;
  }
  .sitePicDiv {
    display: inline-block;
    width: 23%;
    margin-left: 1%;
    margin-right: 1%; 
  }
}
</style>